export default __webpack_public_path__ + "static/media/sticker_mic.498fee03.png";